import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import routes from '../../constants/routes'
import {
  isAuthenticated as getIsAuthenticated,
  hasIncompleteProfile as getHasIncompleteProfile,
} from '../../auth/selectors'

const withUserMustCompleteProfile = (Component) => {
  return (props) => {
    const isAuthenticated = useSelector(getIsAuthenticated)
    const hasIncompleteProfile = useSelector(getHasIncompleteProfile)
    const location = useLocation()

    if (!isAuthenticated) {
      return <Navigate to={routes.LOGIN} state={{ from: location }} replace />
    }

    if (hasIncompleteProfile) {
      if (location.pathname === routes.COMPLETE_PROFILE) {
        return <Component {...props} />
      }
      return <Navigate to={routes.COMPLETE_PROFILE} replace />
    }

    return <Component {...props} />
  }
}

export default withUserMustCompleteProfile
